// 드론이 보고하는 gps_status 는 1~8 의 측위(fix) 단계.
// 5(3D fix) / 6(DGPS) 만 비행 가능하고, 1~4 는 측위가 확보되지 않은 상태다.
// 7,8 은 실장비에서 올라오지 않는다고 확인됐지만, 오면 판단 불가이므로 비행 불가로 본다.
export const GPS_FLIGHT_READY = [5, 6];
// 5 는 비행은 되지만 측위가 불안정할 수 있어 사용자 확인을 한 번 받는다.
export const GPS_NEEDS_CHECK = 5;

export function isGpsFlightReady(gps) {
  return GPS_FLIGHT_READY.includes(Number(gps));
}

/** 장비 표시용 등급. 값이 없으면 null (표시는 "-"). */
export function gpsQuality(gps) {
  const n = Number(gps);
  if (!Number.isInteger(n)) return null;
  if (n >= 5 && n <= 6) return "Good";
  if (n >= 1 && n <= 4) return "Poor";
  return "Unknown";
}
